import { categories } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-200/70 pt-16 pb-8 px-4 md:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="bg-background-50 rounded-2xl p-8 md:p-10 relative overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
            <div className="md:col-span-1">
              <p className="font-heading font-extrabold text-lg text-foreground-950 tracking-tight">
                Kakobuy <span className="text-primary-500">Spreadsheet</span>
              </p>
              <p className="text-xs text-foreground-600 mt-3 leading-relaxed">
                The Largest Free Kakobuy Spreadsheet Directory for Sneakers, Clothing, Bags and Yupoo Sellers. Updated daily with verified products and trusted sellers.
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-label text-foreground-500 uppercase tracking-wider mb-4 font-semibold">Categories</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label text-foreground-500 uppercase tracking-wider mb-4 font-semibold">Guides</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/what-is-kakobuy-spreadsheet" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Buying Guide</Link>
                </li>
                <li>
                  <Link to="/what-is-kakobuy-spreadsheet" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Safety Guide</Link>
                </li>
                <li>
                  <Link to="/what-is-kakobuy-spreadsheet" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Shipping Guide</Link>
                </li>
                <li>
                  <Link to="/what-is-kakobuy-spreadsheet" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">QC Tips</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label text-foreground-500 uppercase tracking-wider mb-4 font-semibold">Articles</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/what-is-kakobuy-spreadsheet" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">What Is Kakobuy Spreadsheet</Link>
                </li>
                <li>
                  <a href="/#faq" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">FAQ</a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Visit Kaspreadsheet</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              &copy; 2026 Kakobuy Spreadsheet. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>Privacy Policy</span>
              <span>|</span>
              <span>Terms of Service</span>
              <span>|</span>
              <span>Updated June 2026</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}